import React, { useEffect, useState, useRef } from "react"
import { useDispatch, shallowEqual, useSelector } from "react-redux"
import { FormattedMessage } from "react-intl"

import { Modal, Button, Spinner } from "react-bootstrap"

import { QuizEmailStudentForm } from "./QuizEmailStudentForm"

import * as actions from "../../../../_redux/takenQuiz/takenQuizAction"

const QuizEmailStudentDialog = ({ history, match }) => {
    const dispatch = useDispatch()

    const id = match && match.params.id
    const qId = match && match.params.qId

    const { currentTakenQuiz, actionsLoading } = useSelector(
        (state) => ({
            currentTakenQuiz: state.takenQuiz.currentTakenQuiz,
            actionsLoading: state.takenQuiz.actionsLoading,
        }),
        shallowEqual
    )

    useEffect(() => {
        if(id) dispatch(actions.fetchTakenQuizById(id, history))
    }, [id])

    useEffect(() => {
        if (currentTakenQuiz !== undefined)
            if (currentTakenQuiz !== null)
                setFormData({
                    ...formData,
                    studentName: currentTakenQuiz.user.fullname,
                    studentEmail: currentTakenQuiz.user.email,
                })
            // else {
            //     console.log('here')
            //     hideModal()
            // }
    }, [currentTakenQuiz])

    const [formData, setFormData] = useState({
        studentName: "",
        studentEmail: "",
        emailSubject: "",
        emailMessage: "",
    })

    const btnRef = useRef()
    const sendEmailClick = () => {
        if (btnRef && btnRef.current) btnRef.current.click()
    }

    const saveEmailInfo = (values) => {
        setFormData({
            ...formData,
            emailSubject: values.emailSubject,
            emailMessage: values.emailMessage,
        })
        dispatch(
            actions.sendEmail(formData.studentName, formData.studentEmail, values.emailSubject, values.emailMessage, qId, history)
        )
    }

    const hideModal = () => {
        history.push(`/teacher/quiz/${qId}/viewStats`)
    }

    return (
        <Modal show={match != null} keyboard={false} backdrop='static' aria-labelledby='example-modal-sizes-title-lg'>
            <Modal.Header closeButton>
                <Modal.Title id='example-modal-sizes-title-lg'>
                    <FormattedMessage id='SEND_EMAIL_TO_STUDENT'></FormattedMessage>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <QuizEmailStudentForm 
                    formData={formData}
                    saveEmailInfo={saveEmailInfo}
                    btnRef={btnRef}
                    />
            </Modal.Body>
            <Modal.Footer>
                <Button variant='primary' onClick={() => sendEmailClick()}>
                    <div className="d-flex align-items-center">
                    <FormattedMessage id='SEND_EMAIL'></FormattedMessage>
                        {actionsLoading &&
                            <Spinner animation="border" className="ml-2" variant="light" />
                        }
                    </div>
                </Button>
                <Button variant='secondary' onClick={() => hideModal()}>
                    <FormattedMessage id='CLOSE'></FormattedMessage>
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default QuizEmailStudentDialog
